var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlBody1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 704,
    viewBox: "0 0 618 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Body / 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.604 500.819C454.604 500.819 376.938 376.697 373.062 345.911C368.956 313.293 372.642 271.173 372.642 271.173L425.088 239.953L438.358 317.589L494.952 495.213",
    fill: "#E576C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.114 493.731C38.114 493.731 35.656 313.823 47.086 284.195C58.516 254.567 79.204 214.845 79.204 214.845L140.558 255.865L107.65 309.155L84.968 490.913",
    fill: "#E576C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.813 77.7203L326.993 339.96L284.393 339.32L288.073 78.7003L286.595 77.6203L288.133 77.7203C288.133 77.7203 264.015 52.7203 254.653 43.3203C260.813 43.7403 266.893 44.2003 272.873 44.5203C289.153 45.3603 303.033 45.9203 315.175 46.8403C316.693 48.9003 320.073 54.5203 319.675 63.5203C319.333 70.8603 318.793 74.4203 318.393 76.1403C318.113 77.3403 317.893 77.6403 317.833 77.7003L317.813 77.7203Z",
    fill: "#CE3D29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 14",
    d: "M213.063 186.051L174.089 245.101",
    stroke: "#FF9929",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.315 85.2603C260.289 81.9723 244.679 52.6683 238.981 41.4683C247.472 41.3727 255.756 42.0293 263.855 42.6714C267.62 42.9698 271.345 43.2652 275.033 43.4803C278.89 43.7043 282.595 43.9081 286.16 44.1042C304.176 45.0953 318.597 45.8887 330.809 48.0843C331.781 51.5923 339.043 89.3463 295.315 85.2603ZM433.047 514.724L474.621 497.194C468.237 489.711 463.299 484.027 463.299 484.027C463.299 484.027 440.695 486.869 436.393 496.987C434.139 502.287 433.153 508.352 433.047 514.724ZM502.601 531.893C501.316 529.37 494.832 521.277 487.489 512.446L434.846 533.622C439.14 556.468 449.587 577.663 449.587 577.663C449.587 577.663 438.781 571.073 436.631 576.837C435.675 579.403 433.505 599.899 473.987 601.279C478.283 601.425 488.623 592.683 488.623 592.683C488.623 592.683 481.085 607.077 492.627 609.905C492.627 609.905 511.229 582.033 511.515 575.831C511.799 569.629 505.829 538.235 502.601 531.893ZM99.1766 516.78L93.5251 498.707L31.5496 503.62C27.2877 515.275 22.3443 529.441 20.5106 537.194C19.0746 543.262 20.7846 564.456 24.2126 576.08C26.1526 582.664 30.4426 588.768 30.4426 588.768C30.4426 588.768 35.5926 600.868 37.5986 601.922C43.2706 604.906 45.7766 599.084 45.7766 599.084C45.7766 599.084 49.6006 616.556 53.4946 614.846C55.8966 613.792 59.4246 610.526 59.5106 606.176C60.0666 578.494 65.4886 549.574 75.0026 544.582C81.1121 541.375 83.3222 552.256 85.3919 562.446C86.546 568.127 87.6563 573.594 89.3746 576.284C94.0266 583.568 112.341 588.76 107.717 576.026C101.382 558.576 101.226 551.245 100.993 540.314C100.982 539.797 100.971 539.273 100.959 538.74C100.691 526.902 99.1766 516.78 99.1766 516.78Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    opacity: 0.146601,
    d: "M457.852 521.415C457.852 521.415 463.534 542.873 483.028 549.559C489.844 551.897 488.142 579.497 504.85 576.195",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shirt color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.436 340.954V60.9541H343.206V340.954H252.436ZM407.27 525.592L497.012 487.753L503.82 505.876L412.54 542.595L407.27 525.592ZM129.871 476.748L28.6374 485.516L28.9494 503.826L129.871 495.826V476.748Z",
    fill: "#FCBDA4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Coat",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5251 498.707L129.871 495.826V476.748L28.6374 485.516L28.6378 485.541L20.5724 486.2C20.5724 486.2 23.1144 328 53.4724 241.84C80.0344 166.5 128.492 84.6795 166.332 60.8595C168.594 59.4395 170.854 58.0995 173.094 56.8795L165.634 46.7395L247.694 23.9995C247.694 23.9995 245.174 33.8595 253.794 42.4595C253.96 42.6394 254.144 42.8192 254.333 43.0044L254.334 43.0048L254.334 43.0052C254.439 43.108 254.546 43.2125 254.652 43.3195C264.014 52.7195 288.134 77.7195 288.134 77.7195L286.594 77.6195L288.072 78.6995L284.392 339.32L279.274 703.419L69.5144 697.099L85.5436 563.192C86.6445 568.601 87.7317 573.712 89.3746 576.284C94.0266 583.568 112.341 588.76 107.717 576.026C101.382 558.575 101.226 551.245 100.993 540.313L100.993 540.307C100.982 539.793 100.971 539.271 100.959 538.74C100.691 526.901 99.1766 516.78 99.1766 516.78L93.5251 498.707ZM402.614 527.539L421.354 703.419H339.714L326.992 339.961L367.554 340.553L326.992 339.96L317.814 77.7195L317.832 77.6995C317.894 77.6395 318.114 77.3395 318.394 76.1395C318.794 74.4195 319.332 70.8595 319.674 63.5195C320.072 54.5195 316.694 48.8995 315.174 46.8395C314.734 46.2595 314.454 45.9595 314.454 45.9595L315.934 31.9995L380.654 64.0595L377.274 65.8395L365.314 72.1879L377.275 65.8399C378.913 67.1199 380.533 68.4999 382.133 69.9799C434.613 118.14 442.275 293.98 442.275 293.98L503.653 484.94L402.614 527.539ZM361.675 143.08L381.272 327.122L361.674 143.08L348.694 74.5995L363.633 73.0799L348.695 74.5999L361.675 143.08Z",
    fill: "#CE3D29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.833 77.6999L318.393 76.1399C318.115 77.3399 317.893 77.6399 317.833 77.6999Z",
    fill: "#CE3D29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 24",
    opacity: 0.20459,
    d: "M165.632 46.7349C165.632 46.7349 192.652 81.3729 223.514 87.5269C252.716 93.3509 288.136 77.7149 288.136 77.7149",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 25",
    opacity: 0.20459,
    d: "M380.655 64.0688C380.655 64.0688 378.281 81.2608 367.055 85.5688C347.383 93.1148 321.749 76.4128 321.749 76.4128",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 26",
    opacity: 0.201265,
    d: "M402.663 527.902L379.853 200.954",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    opacity: 0.201265,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.805 215.884C354.597 222.76 349.825 228.196 344.143 228.026C338.461 227.854 334.023 222.14 334.233 215.264C334.439 208.388 339.213 202.952 344.893 203.124C350.575 203.294 355.013 209.008 354.805 215.884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    opacity: 0.201265,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.68 124.166C349.472 131.042 344.7 136.478 339.02 136.308C333.338 136.136 328.9 130.422 329.108 123.546C329.314 116.67 334.088 111.234 339.77 111.406C345.452 111.576 349.888 117.29 349.68 124.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    opacity: 0.201265,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.928 307.603C359.72 314.479 354.948 319.915 349.266 319.745C343.586 319.573 339.148 313.859 339.356 306.983C339.562 300.107 344.336 294.671 350.016 294.843C355.698 295.013 360.136 300.727 359.928 307.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 32",
    opacity: 0.196568,
    d: "M213.063 173.56L174.089 290.184L156.745 473.774L129.871 476.748",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 33",
    opacity: 0.201265,
    d: "M159.577 443.796L43.925 453.978",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 34",
    opacity: 0.201265,
    d: "M402.663 500.819L476.335 467.519",
    stroke: "black",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlBody1);
export default __webpack_public_path__ + "static/media/Girl-Body-1.853719c5.svg";
export { ForwardRef as ReactComponent };